export class PostSitePageRequestDto {
    siteId: number;
    path: string;
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/models/post/PostSitePageRequestDto.ts